import { createContext, useContext, useEffect, useState } from "react";

const STR = {
  navHome: { en: "Home", ur: "ہوم" },
  navPlatform: { en: "Platform", ur: "پلیٹ فارم" },
  navCompany: { en: "Company", ur: "کمپنی" },
  navTalk: { en: "Talk to us", ur: "ہم سے بات کریں" },
  footerTag: { en: "Clean power, made easy.", ur: "صاف بجلی، آسان طریقے سے۔" },
  footerRights: { en: "© 2026 AsaanCharge · Karachi, Pakistan", ur: "© 2026 آسان چارج · کراچی، پاکستان" },
  ctaL1: { en: "Power, delivered.", ur: "بجلی، آپ کی دہلیز پر۔" },
  ctaL2: { en: "Join the pilot.", ur: "پائلٹ میں شامل ہوں۔" },
  ctaBtn: { en: "Start a conversation", ur: "گفتگو شروع کریں" },
  whats: { en: "Chat with us", ur: "ہم سے چیٹ کریں" },
  formName: { en: "Name", ur: "نام" },
  formPhone: { en: "Phone", ur: "فون" },
  formCity: { en: "City", ur: "شہر" },
  formIam: { en: "I am a", ur: "میں ہوں" },
  phName: { en: "Your name", ur: "آپ کا نام" },
  phCity: { en: "Karachi", ur: "کراچی" },
  optBusiness: { en: "Business", ur: "کاروبار" },
  optEV: { en: "EV Owner", ur: "ای وی مالک" },
  optInvestor: { en: "Investor", ur: "سرمایہ کار" },
  optEvent: { en: "Event Organiser", ur: "ایونٹ منتظم" },
  optOther: { en: "Other", ur: "دیگر" },
  formSubmit: { en: "Send my details", ur: "معلومات بھیجیں" },
  formSending: { en: "Sending your note…", ur: "بھیجا جا رہا ہے…" },
  formThanks: { en: "Thanks — we’ll be in touch soon.", ur: "شکریہ — ہم جلد رابطہ کریں گے۔" },
  formFail: { en: "We couldn’t send that just now. Please WhatsApp us instead.", ur: "ابھی بھیجا نہ جا سکا۔ براہ کرم واٹس ایپ کریں۔" },
  heroEyebrow: { en: "Distributed energy network · Pakistan", ur: "مُنقسم توانائی نیٹ ورک · پاکستان" },
  heroL1: { en: "Clean energy,", ur: "صاف توانائی،" },
  heroL2: { en: "delivered where it’s", ur: "جہاں ضرورت ہے" },
  heroL3: { en: "needed.", ur: "وہاں پہنچائی جاتی۔" },
  heroSub: { en: "Charged battery modules, delivered wherever you need power — starting with doorstep EV charging.", ur: "چارج شدہ بیٹری ماڈیولز، جہاں بجلی چاہیے وہاں ڈیلیور — آغاز ڈور اسٹیپ ای وی چارجنگ سے۔" },
  heroCta1: { en: "Join the Pilot", ur: "پائلٹ میں شامل ہوں" },
  heroCta2: { en: "Explore the Platform", ur: "پلیٹ فارم دیکھیں" },
  heroNote1: { en: "Proof-of-concept in Karachi", ur: "کراچی میں آزمائشی مرحلہ" },
  heroNote2: { en: "Built for Pakistan", ur: "پاکستان کے لیے بنایا گیا" },
  statEyebrow: { en: "The network in numbers", ur: "نیٹ ورک کی تفصیل" },
  stat1N: { en: "01", ur: "01" }, stat1L: { en: "POC prototype", ur: "آزمائشی ماڈیول" },
  stat2N: { en: "01", ur: "01" }, stat2L: { en: "Pilot city — Karachi", ur: "پائلٹ شہر — کراچی" },
  stat3N: { en: "03", ur: "03" }, stat3L: { en: "Applications", ur: "استعمال" },
  stat4N: { en: "24/7", ur: "24/7" }, stat4L: { en: "Delivery target", ur: "ڈیلیوری ہدف" },
  chip1: { en: "charged with clean energy", ur: "صاف توانائی سے چارج" },
  chip2: { en: "delivered to your door", ur: "آپ کی دہلیز تک ڈیلیوری" },
  mediaTag: { en: "AsaanCharger1 · portable module", ur: "AsaanCharger1 · پورٹیبل ماڈیول" },
  probEyebrow: { en: "The problem", ur: "مسئلہ" },
  probL1: { en: "Power shouldn’t be", ur: "بجلی اتنی" },
  probL2: { en: "this complicated.", ur: "مشکل کیوں؟" },
  probP: { en: "Outages cost hours. Diesel costs money.", ur: "بندش وقت کھوتی ہے۔ ڈیزل پیسہ کھاتا ہے۔" },
  prob1: { en: "Power cuts disrupt business daily", ur: "بجلی کی بندش روز کاروبار متاثر کرتی ہے" },
  prob2: { en: "Grid and diesel power are expensive", ur: "گرڈ اور ڈیزل بجلی مہنگی ہے" },
  prob3: { en: "No easy backup or charging option", ur: "بیک اپ یا چارجنگ کی آسان سہولت نہیں" },
  useEyebrow: { en: "What we do", ur: "ہم کیا کرتے ہیں" },
  useL1: { en: "One network.", ur: "ایک نیٹ ورک۔" },
  useL2: { en: "Many uses.", ur: "بہت سے استعمال۔" },
  useP: { en: "Portable modules, delivered as a service — not sold as hardware.", ur: "پورٹیبل ماڈیولز، سروس کی صورت میں — ہارڈویئر فروخت نہیں۔" },
  tagFlagship: { en: "Flagship", ur: "نمایاں" },
  use1T: { en: "Doorstep EV charging", ur: "ڈور اسٹیپ ای وی چارجنگ" },
  use1P: { en: "Charged modules come to your EV.", ur: "چارج شدہ ماڈیول آپ کی ای وی تک آتے ہیں۔" },
  use2T: { en: "Events & outdoor", ur: "ایونٹس اور آؤٹ ڈور" },
  use2P: { en: "Quiet, clean power — no generators.", ur: "خاموش، صاف بجلی — بغیر جنریٹر کے۔" },
  use3T: { en: "Business backup", ur: "کاروباری بیک اپ" },
  use3P: { en: "Stay running when the grid fails.", ur: "گرڈ جواب دے تو بھی کام جاری رہے۔" },
  teaserMore: { en: "See how the platform works", ur: "دیکھیں پلیٹ فارم کیسے کام کرتا ہے" },
  vidEyebrow: { en: "Watch", ur: "دیکھیں" },
  vidL1: { en: "See it", ur: "اسے" },
  vidL2: { en: "in motion.", ur: "چلتے دیکھیں۔" },
  vidEn: { en: "English narration", ur: "English narration" },
  vidUr: { en: "اردو وائس اوور", ur: "اردو وائس اوور" },
  vidFor: { en: "for customers & investors", ur: "صارفین اور سرمایہ کاروں کے لیے" },
  vidP: { en: "One 60-second film. Switch the language toggle for the Urdu version.", ur: "ایک 60 سیکنڈ کی فلم۔ اردو کے لیے زبان کا بٹن دبائیں۔" },
  evKicker: { en: "Star application", ur: "نمایاں استعمال" },
  evL1: { en: "Doorstep EV charging,", ur: "ڈور اسٹیپ ای وی چارجنگ،" },
  evL2: { en: "without the infrastructure.", ur: "بغیر انفراسٹرکچر کے۔" },
  evP: { en: "No charger? We bring charged modules to your EV — anywhere in the service area.", ur: "چارجر نہیں؟ ہم چارج شدہ ماڈیول آپ کی ای وی تک لاتے ہیں — سروس ایریا میں کہیں بھی۔" },
  evLink: { en: "Request a call-out", ur: "کال آؤٹ کی درخواست" },
  mapEyebrow: { en: "Delivered anywhere", ur: "ہر جگہ ڈیلیوری" },
  mapL1: { en: "Any location.", ur: "کوئی بھی مقام۔" },
  mapL2: { en: "We come to you.", ur: "ہم آپ کے پاس آتے ہیں۔" },
  mapP: { en: "Charged modules delivered to any location in the service area — today, Karachi.", ur: "چارج شدہ ماڈیولز سروس ایریا میں کسی بھی مقام پر — فی الحال، کراچی۔" },
  invEyebrow: { en: "Get involved", ur: "شامل ہوں" },
  invL1: { en: "Three ways to be", ur: "شامل ہونے کے" },
  invL2: { en: "part of it.", ur: "تین طریقے۔" },
  path1T: { en: "Pilot customers", ur: "پائلٹ صارفین" },
  path1P: { en: "Businesses and EV owners in Karachi — be first.", ur: "کراچی کے کاروبار اور ای وی مالکان — سب سے پہلے شامل ہوں۔" },
  path1C: { en: "Join the pilot", ur: "پائلٹ میں شامل ہوں" },
  path2T: { en: "Events & outdoor", ur: "ایونٹس اور آؤٹ ڈور" },
  path2P: { en: "Quiet, clean power for your event.", ur: "آپ کے ایونٹ کے لیے خاموش، صاف بجلی۔" },
  path2C: { en: "Power my event", ur: "میرے ایونٹ کے لیے بجلی" },
  path3T: { en: "Investors", ur: "سرمایہ کار" },
  path3P: { en: "Our POC is testing energy delivered cheaper than commercial rates. Talk to us.", ur: "ہمارا پروف آف کانسیپٹ کمرشل ریٹس سے سستی بجلی آزما رہا ہے — بات کریں۔" },
  path3C: { en: "Start a conversation", ur: "گفتگو شروع کریں" },
  statusMark: { en: "Live status", ur: "تازہ صورتحال" },
  statusL1: { en: "AsaanCharger1 in proof-of-concept testing", ur: "AsaanCharger1 آزمائشی مرحلے میں" },
  statusL2: { en: "in Karachi, Pakistan.", ur: "کراچی، پاکستان میں۔" },
  statusP: { en: "Pilot customers wanted.", ur: "پائلٹ صارفین درکار ہیں۔" },
  platEyebrow: { en: "The platform", ur: "پلیٹ فارم" },
  platL1: { en: "A distributed energy network,", ur: "ایک مُنقسم توانائی نیٹ ورک،" },
  platL2: { en: "delivered as a service.", ur: "سروس کی صورت میں۔" },
  platSub: { en: "You don’t buy batteries. You subscribe to power — we own, charge, deliver and maintain every module.", ur: "آپ بیٹریاں نہیں خریدتے۔ آپ بجلی کی سبسکرپشن لیتے ہیں — ہر ماڈیول ہمارا، ہم چارج کریں، ڈیلیور کریں، سنبھالیں۔" },
  modelEyebrow: { en: "The model", ur: "ماڈل" },
  modelL1: { en: "Energy-as-a-Service.", ur: "توانائی بحیثیت سروس۔" },
  modelL2: { en: "Not hardware.", ur: "ہارڈویئر نہیں۔" },
  modelP: { en: "Power becomes an expense you control.", ur: "بجلی ایک قابلِ کنٹرول خرچ بن جاتی ہے۔" },
  model1T: { en: "No upfront cost", ur: "کوئی ابتدائی لاگت نہیں" },
  model1P: { en: "You never buy a battery.", ur: "آپ کبھی بیٹری نہیں خریدتے۔" },
  model2T: { en: "Power by subscription", ur: "سبسکرپشن سے بجلی" },
  model2P: { en: "Pay per delivery or monthly.", ur: "فی ڈیلیوری یا ماہانہ ادائیگی۔" },
  model3T: { en: "We run everything", ur: "سب کچھ ہم سنبھالتے ہیں" },
  model3P: { en: "We own, charge, move and maintain.", ur: "ملکیت، چارجنگ، ڈیلیوری، دیکھ بھال — سب ہمارا۔" },
  flowEyebrow: { en: "How it works", ur: "طریقہ کار" },
  flowL1: { en: "Energy finds", ur: "توانائی اپنی" },
  flowL2: { en: "its way.", ur: "منزل پاتی ہے۔" },
  flowP: { en: "A simple loop from our network to your door.", ur: "ہمارے نیٹ ورک سے آپ کی دہلیز تک ایک آسان چکر۔" },
  flow1T: { en: "Charge", ur: "چارج" },
  flow1P: { en: "Modules charged with clean energy.", ur: "ماڈیول صاف توانائی سے چارج ہوتے ہیں۔" },
  flow2T: { en: "Dispatch", ur: "روانگی" },
  flow2P: { en: "Full modules head out across the city.", ur: "بھرے ماڈیول شہر بھر میں روانہ۔" },
  flow3T: { en: "Deliver", ur: "ڈیلیوری" },
  flow3P: { en: "Power reaches EVs, events and shops.", ur: "بجلی ای ویز، ایونٹس اور دکانوں تک۔" },
  flow4T: { en: "Combine", ur: "جوڑیں" },
  flow4P: { en: "Stack modules for bigger capacity.", ur: "زیادہ صلاحیت کے لیے ماڈیول جوڑیں۔" },
  modEyebrow: { en: "The hardware", ur: "ہارڈویئر" },
  modL1: { en: "Meet ", ur: "ملیے " },
  modL2: { en: "AsaanCharger1.", ur: "AsaanCharger1 سے۔" },
  modP: { en: "Our first mobile charging unit — ready power, wherever it is needed.", ur: "ہماری پہلی موبائل چارجنگ یونٹ — تیار بجلی، جہاں بھی ضرورت ہو۔" },
  specCap: { en: "Battery", ur: "بیٹری" },
  specOut: { en: "Power", ur: "پاور" },
  specScale: { en: "Combine", ur: "مجموعی صلاحیت" },
  specBy: { en: "Inverter", ur: "انورٹر" },
  specMob: { en: "EV charging", ur: "ای وی چارجنگ" },
  specCapV: { en: "48V per module", ur: "48V فی ماڈیول" },
  specOutV: { en: "5 kW per module", ur: "5 kW فی ماڈیول" },
  specScaleV: { en: "3–4 modules together", ur: "3–4 ماڈیولز یکساں" },
  specByV: { en: "6 kW inverter", ur: "6 kW انورٹر" },
  specMobV: { en: "2 kW EV charger", ur: "2 kW ای وی چارجر" },
  specNote: { en: "Proof-of-concept stage — specifications are indicative.", ur: "آزمائشی مرحلہ — تفصیلات تخمینی ہیں۔" },
  modCaption: { en: "Every module charged, tracked and ready to roll.", ur: "ہر ماڈیول چارج، رجسٹرڈ اور روانگی کے لیے تیار۔" },
  stCaption: { en: "Battery racks at our hub — modules swapped on schedule.", ur: "ہب پر بیٹری ریکس — ماڈیولز مقررہ وقت پر تبدیل ہوتے ہیں۔" },
  modTag: { en: "Proof-of-concept prototype", ur: "آزمائشی نمونہ" },
  stEyebrow: { en: "Beyond doorstep", ur: "دہلیز سے آگے" },
  stL1: { en: "Fixed stations,", ur: "مستقل اسٹیشنز،" },
  stL2: { en: "battery-powered.", ur: "بیٹری سے چلنے والے۔" },
  stP: { en: "Charging points can run on our modules by subscription — the grid becomes emergency backup, or isn’t needed at all.", ur: "چارجنگ پوائنٹس ہمارے ماڈیولز سے سبسکرپشن پر چل سکتے ہیں — گرڈ صرف ایمرجنسی بیک اپ رہ جائے، یا بالکل ضرورت نہ ہو۔" },
  stPoint1: { en: "No grid connection required", ur: "گرڈ کنکشن کی ضرورت نہیں" },
  stPoint2: { en: "Modules swapped on a schedule", ur: "ماڈیولز مقررہ وقت پر بدلے جاتے ہیں" },
  stPoint3: { en: "Scales by adding modules", ur: "ماڈیول بڑھا کر توسیع" },
  appsEyebrow: { en: "Applications", ur: "استعمال" },
  appsL1: { en: "Where the network", ur: "نیٹ ورک کہاں" },
  appsL2: { en: "goes to work.", ur: "کام کرتا ہے۔" },
  appsP: { en: "One service, many situations.", ur: "ایک سروس، بہت سے مواقع۔" },
  tagEvents: { en: "Events", ur: "ایونٹس" },
  tagBackup: { en: "Backup", ur: "بیک اپ" },
  app1T: { en: "Doorstep EV charging", ur: "ڈور اسٹیپ ای وی چارجنگ" },
  app1P: { en: "A charge point that comes to the vehicle.", ur: "چارج پوائنٹ خود گاڑی کے پاس آتا ہے۔" },
  app2T: { en: "Events & outdoor", ur: "ایونٹس اور آؤٹ ڈور" },
  app2P: { en: "Silent, fume-free power for any setup.", ur: "ہر سیٹ اپ کے لیے خاموش، صاف بجلی۔" },
  app3T: { en: "Business backup", ur: "کاروباری بیک اپ" },
  app3P: { en: "Backup power on demand, delivered.", ur: "طلب پر بیک اپ بجلی، ڈیلیور شدہ۔" },
  diffEyebrow: { en: "What makes it different", ur: "خصوصیات" },
  diffL1: { en: "Small modules.", ur: "چھوٹے ماڈیول۔" },
  diffL2: { en: "Big difference.", ur: "بڑا فرق۔" },
  diffP: { en: "Asaan means easy.", ur: "آسان کا مطلب ہے سہولت۔" },
  ben1T: { en: "Modular", ur: "ماڈیولر" },
  ben1P: { en: "Add modules to scale.", ur: "ماڈیول جوڑ کر بڑھائیں۔" },
  ben2T: { en: "Plug-and-play", ur: "پلگ اینڈ پلے" },
  ben2P: { en: "No rewiring needed.", ur: "نئی وائرنگ کی ضرورت نہیں۔" },
  ben3T: { en: "Quiet and clean", ur: "خاموش اور صاف" },
  ben3P: { en: "No noise, no fumes.", ur: "نہ شور، نہ دھواں۔" },
  ben4T: { en: "Delivered", ur: "ڈیلیور شدہ" },
  ben4P: { en: "Power comes to you.", ur: "بجلی آپ کے پاس آتی ہے۔" },
  compEyebrow: { en: "The company", ur: "کمپنی" },
  compL1: { en: "Clean power,", ur: "صاف بجلی،" },
  compL2: { en: "made Asaan.", ur: "اب انتہائی آسان۔" },
  compSub: { en: "A Karachi-based energy startup in proof-of-concept testing, building Pakistan’s first portable power network.", ur: "کراچی کی توانائی اسٹارٹ اپ، آزمائشی مرحلے میں — پاکستان کا پہلا پورٹیبل بجلی نیٹ ورک بنا رہی ہے۔" },
  fndEyebrow: { en: "Why we started AsaanCharge", ur: "آسان چارج کیوں بنایا" },
  fndL1: { en: "Built from two sides of the ", ur: "بجلی کے مسئلے کے " },
  fndL2: { en: "power problem.", ur: "دونوں پہلوؤں سے۔" },
  fndLead: { en: "Zubair brings the engineering. Muhammed brings the operations.", ur: "ذبیر انجینئرنگ لاتے ہیں۔ محمد آپریشنز لاتے ہیں۔" },
  fnd1H: { en: "Engineering for what comes next.", ur: "آنے والے کل کی انجینئرنگ۔" },
  fnd1P: { en: "Power electronics, e-mobility and renewable energy systems.", ur: "پاور الیکٹرانکس، ای موبلٹی اور قابلِ تجدید توانائی کے نظام۔" },
  fnd2H: { en: "13+ years on the ground.", ur: "13+ سال کا میدانی تجربہ۔" },
  fnd2P: { en: "Business, logistics and operations experience in Karachi.", ur: "کراچی میں کاروبار، لاجسٹکس اور آپریشنز کا تجربہ۔" },
  fndCaption: { en: "Portable power, on demand.", ur: "پورٹیبل بجلی، طلب کے مطابق۔" },
  whereEyebrow: { en: "Where we are", ur: "ہم کہاں ہیں" },
  whereL1: { en: "Honest about", ur: "سفر کے بارے میں" },
  whereL2: { en: "the journey.", ur: "پوری ایمانداری سے۔" },
  whereP: { en: "We are early, and we say so.", ur: "ہم ابھی آغاز میں ہیں، اور یہی کہتے ہیں۔" },
  ms1T: { en: "Concept & design", ur: "تصور اور ڈیزائن" },
  ms1P: { en: "Model validated, designs completed.", ur: "ماڈل کی توثیق اور ڈیزائن مکمل۔" },
  ms2T: { en: "Proof of concept", ur: "آزمائشی نمونہ" },
  ms2P: { en: "Testing AsaanCharger1 deliveries in Karachi.", ur: "کراچی میں AsaanCharger1 ڈیلیوری کی آزمائش۔" },
  msNow: { en: " — happening now", ur: " — ابھی جاری" },
  ms3T: { en: "Pilot programme", ur: "پائلٹ پروگرام" },
  ms3P: { en: "Recruiting businesses and EV owners.", ur: "کاروبار اور ای وی مالکان شامل ہو رہے ہیں۔" },
  ms4T: { en: "Commercial launch", ur: "تجارتی آغاز" },
  ms4P: { en: "City-by-city rollout.", ur: "شہر در شہر پھیلاؤ۔" },
  conEyebrow: { en: "Start a conversation", ur: "گفتگو شروع کریں" },
  conL1: { en: "Let’s make power", ur: "بجلی کو بنائیں" },
  conL2: { en: "more Asaan.", ur: "مزید آسان۔" },
  conP: { en: "Pilot customer, EV owner or investor — tell us what you need.", ur: "پائلٹ صارف، ای وی مالک یا سرمایہ کار — اپنی ضرورت بتائیں۔" },
  conLoc: { en: "Karachi, Pakistan", ur: "کراچی، پاکستان" },
  conWhats: { en: "WhatsApp us directly", ur: "ہمیں براہ راست واٹس ایپ کریں" },
};

const LangCtx = createContext({ lang: "en", toggle: () => {}, t: (k) => k });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ac-lang") || "en");
  useEffect(() => { localStorage.setItem("ac-lang", lang); }, [lang]);
  const toggle = () => setLang((l) => (l === "en" ? "ur" : "en"));
  const t = (key) => (STR[key] && STR[key][lang]) || (STR[key] && STR[key].en) || key;
  return <LangCtx.Provider value={{ lang, toggle, t }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
